export default __webpack_public_path__ + "static/media/18-date with someone.dcf3b237.svg";